import { print } from 'graphql';
import { gql } from 'graphql-tag';
import type { MigrationStrategies, RxCollection, RxDocument, RxJsonSchema } from 'rxdb';

import { getDateModified } from '../../utilities/utilityFunctions';
import { defaultDoc, getValueFromLocalStorage } from '../share/defaultDoc';

export interface ElevationRange {
  readonly areaId: string;
  readonly areaPcsId: string;
  readonly name: string;
  readonly fkParentArea: number;
  readonly parentAreaName: string;
  readonly parentAreaPcsId: string;
  readonly lowerElevation: string;
  readonly upperElevation: string;
  readonly trafficSafety: number;
  readonly isActive: boolean;
  readonly site: number;
  readonly discipline: number;
  readonly dateCreated: string;
  readonly dateModified: string;
}

export const elevationRangeSchema: RxJsonSchema<ElevationRange> = {
  type: 'object',
  version: 1,
  description: 'describes elevation range',
  primaryKey: 'areaId',
  properties: {
    areaId: { type: 'string', maxLength: 36 },
    name: { type: ['string', 'null'] },
    areaPcsId: { type: ['string', 'null'] },
    fkParentArea: { type: ['number', 'null'] },
    parentAreaName: { type: ['string', 'null'] },
    parentAreaPcsId: { type: ['string', 'null'] },
    lowerElevation: { type: ['string', 'null'] },
    upperElevation: { type: ['string', 'null'] },
    trafficSafety: { type: ['number', 'null'] },
    isActive: { type: ['boolean', 'null'] },
    site: { type: ['number', 'null'] },
    discipline: { type: ['number', 'null'] },
    dateCreated: { type: ['string', 'null'] },
    dateModified: { type: ['string', 'null'] },
  },
};

export type ElevationRangeCollection = RxCollection<ElevationRange> | null;
export type ElevationRangeDocument = RxDocument<ElevationRange>;

export const elevationRangePullQueryBuilder = (document: ElevationRange) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }
  const query = print(gql`
    query areasElevationHeightRange($site: Int!, $lastRequested: DateTime) {
      areasElevationHeightRange(site: $site, lastRequested: $lastRequested) {
        areaId
        name
        fkParentArea
        parentAreaName
        parentAreaPcsId
        lowerElevation
        upperElevation
        trafficSafety
        isActive
        site
        areaPcsId
        discipline
        dateCreated
        dateModified
      }
    }
  `);
  return {
    query,
    variables: {
      site: JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
      lastRequested: getDateModified(
        doc?.dateModified,
        doc?.dateCreated,
        doc.site,
        JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
        JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
        JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
      ),
    },
  };
};

export const elevationRangeMigrationStrategies: MigrationStrategies = {
  1: (oldDoc: ElevationRangeDocument) => ({
    ...oldDoc,
    fkParentArea: oldDoc.fkParentArea || 0,
    parentAreaName: oldDoc.parentAreaName || '',
    parentAreaPcsId: oldDoc.parentAreaPcsId || '',
  }),
};

export default {};
